import { render } from "./TournamentView.vue?vue&type=template&id=6da098bb&ts=true"
import script from "./TournamentView.vue?vue&type=script&lang=ts"
export * from "./TournamentView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__